import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import { HOME_CATEGORY_NAME_KEY } from '../../config/constants';
import { useSelectCategory } from '../../hooks/useSelectCategory';
import { DEFAULT_LANGUAGE } from '../../i18n/constants';
import { getUserLanguage } from '../../i18n/helpers';
import { HOME_CATEGORY_ID } from '../../stores/categories/CategoriesStore';
import { useStores } from '../../stores/useStores';

export const Categories = observer(({ isFtueRewardsStep }: { isFtueRewardsStep?: boolean }) => {
  const { categoriesStore } = useStores();
  const { t, i18n } = useTranslation();
  const { selectCategory } = useSelectCategory();
  const { height } = useWindowSize();

  const { gameId } = useParams();

  if (gameId) {
    return null;
  }

  const language = getUserLanguage(i18n.language);

  // If the user is in the FTUE rewards step, we only show the first 6 categories (home and 5 more)
  // to avoid the rewards menu item being hidden from the view.
  const categoriesIds =
    isFtueRewardsStep && height > 0 && height < 800
      ? categoriesStore.categoriesIds.slice(0, 5)
      : categoriesStore.categoriesIds;

  return (
    <ul className="side-menu__categories">
      <li>
        <button
          className={classNames('side-menu__category', {
            'side-menu__category_active': categoriesStore.currentId === HOME_CATEGORY_ID,
          })}
          data-testid="side-menu-category-Home"
          onClick={() => selectCategory(-1)}
        >
          {t(HOME_CATEGORY_NAME_KEY)}
        </button>
      </li>
      {categoriesIds.map((id) => {
        const category = categoriesStore.categoriesRegistry[id];

        if (!category?.showInHamburgerMenu) {
          return null;
        }

        return (
          <li key={id}>
            <button
              className={classNames('side-menu__category', {
                'side-menu__category_active': categoriesStore.currentId === id,
              })}
              data-testid={`side-menu-category-${category.name[DEFAULT_LANGUAGE]}`}
              onClick={() => selectCategory(category.masterGameSubCategoryId)}
            >
              {category.name[language] || category.name[DEFAULT_LANGUAGE]}
            </button>
          </li>
        );
      })}
    </ul>
  );
});
